module.exports = __webpack_public_path__ + "img/workbenchCandidates.b2c96f55.svg";